import $http from '@/http.js';
import router from '../../../router';

function groupBy(collection, property) {
  let i = 0;
  let val;
  let index;
  const values = [];
  const result = [];

  for (i; i < collection.length; i++) {
    val = collection[i][property];
    index = values.indexOf(val);
    if (index > -1) {
      result[index].push(collection[i]);
    } else {
      values.push(val);
      result.push([collection[i]]);
    }
  }
  return result;
}

export const setSectorsList = async (
  { commit, dispatch, getters },
  loadedBefore
) => {
  let cupom = getters.cupomCode;
  let productsCodeUrl = getters.productsCodeUrl;
  let removeScheduledCampaigns = '';
  if (getters.couponPreSale) cupom = getters.couponPreSale;

  if (getters.removeScheduledCampaigns)
    removeScheduledCampaigns = getters.removeScheduledCampaigns;
  try {
    dispatch('addLoading');

    if (!loadedBefore) {
      dispatch('setSkeleton', true);
      commit('SET_SECTORS_LIST', []);
      commit('SET_NOSECTOR_LIST', []);
      commit('SET_SPECIAL_CUPOM', false);
    }

    let data = null;
    let error = null;
    await $http
      .get(`pdv/v3/products/sectors/${getters.eventID}`, {
        params: {
          cupom: cupom,
          product_ids: productsCodeUrl,
          removeScheduledCampaigns,
        },
      })
      .then(resp => {
        commit('SET_SALE_UNINITIATED', '');
        if (!getters.timeToViewProducts)
          commit('SET_TIME_TO_VIEW_PRODUCTS', Math.floor(Date.now() / 1000));
        data = resp.data;
      })
      .catch(e => {
        if (
          router.history.current.query &&
          router.history.current.query.listar_apresentacoes
        )
          dispatch('setSkeleton', false);

        if (e && e.response) error = e.response;
      });

    if (data && data.cupomData && data.cupomData.campaign_type === 'B')
      commit('SET_CUPOM_CARD', true);

    if (
      getters.eventDetails.site_visibilidade === 'Y' &&
      !data.isCupomValid &&
      !getters.validatedPreSale
    ) {
      commit('SET_SHOW_PRE_SALE', true);
      dispatch('setSkeleton', false);
      if (cupom)
        dispatch('openSnackbar', {
          message: 'Código Inválido.',
          color: 'error',
        });
      return;
    } else if (
      getters.eventDetails.site_visibilidade === 'Y' &&
      data.isCupomValid
    ) {
      commit('SET_SHOW_PRE_SALE', false);
      commit('SET_VALIDATED_PRE_SALE', true);
      commit('SET_COUPON_PRE_SALE', cupom);
    }

    commit('SET_CREATE_ORDER_IN_PROGRESS', false);

    if (error && error.data && error.data.message)
      commit('SET_SALE_UNINITIATED', error.data.message);

    commit('SET_IS_CUPOM_TRACKING', data.isCupomTracking);
    commit('SET_PRODUCTS_ALL', data.products);
    commit('SET_CUPOM_DATA', data.cupomData);
    if (data.cupomMessage) {
      commit('SET_CUPOM_MESSAGE', data.cupomMessage);
    }
    if (data.cupomData && data.cupomData.max_order_products) {
      commit(
        'SET_EVENT_MAX_PER_CART_COUPON',
        data.cupomData.max_order_products
      );
    }
    var cupomCode = localStorage.getItem(`cupomCode`);
    var isNumbercupomCode = Number(cupomCode);

    if (
      data.hasCupom &&
      cupomCode &&
      cupomCode.length === 6 &&
      isNumbercupomCode &&
      Number.isInteger(isNumbercupomCode) &&
      data.cupomData &&
      data.cupomData.campaign_type === 'B'
    ) {
      commit('SET_SPECIAL_CUPOM', true);
    }
    const sectors = data.sectors;
    var zeroSector = null;

    sectors.forEach(sectors => {
      if (sectors.codigo === 0) zeroSector = true;

      const products = groupBy(sectors.products, 'codigo_produto');

      products.forEach(types => {
        types.forEach(product => {
          product.quantidade = 0;
          if (!product.quantidade_minima) product.quantidade_minima = 1;
          if (!product.quantidade_maxima) product.quantidade_maxima = 5;
          product.nome = product.nome.replace('<br>', '');
          product.nome_tipo = product.nome_tipo.replace('<br>', '');
          switch (product.sexo) {
            case 'F':
              product.sexo = 'Feminino';
              break;
            case 'M':
              product.sexo = 'Masculino';
              break;
            default:
              product.sexo = 'Unissex';
              break;
          }
        });
      });
    });

    if (zeroSector) {
      let noSectorProducts = sectors.filter(el => el.codigo === 0)[0].products;

      const groupedProducts = groupBy(noSectorProducts, 'codigo_produto');
      commit(
        'SET_SEPARATE_PRODUCTS',
        sectors.filter(el => el.codigo === 0)[0].products
      );
      commit('SET_NOSECTOR_LIST', groupedProducts);
    }
    let sectorsList = sectors.filter(el => el.codigo !== 0);
    let checkoutState = JSON.parse(localStorage.getItem('checkoutState'));

    if (!checkoutState) checkoutState = {};

    if (
      sectorsList.length === 1 &&
      !zeroSector &&
      !checkoutState[getters.eventID]
    ) {
      dispatch('setSelectedSector', sectorsList[0]);
      commit('SET_SHOW_DEFAULT', false);
    } else if (loadedBefore) {
      commit('SET_SHOW_DEFAULT', false);
    } else {
      commit('SET_SHOW_DEFAULT', true);
    }

    commit('SET_IS_VALID_CUPOM_CODE', data.isCupomValid);
    commit('SET_SECTORS_LIST', sectorsList);
    if (sectors && sectors[0] && sectors[0].products) {
      commit('SET_ALL_PRODUCTS', sectors[0].products);
    }
    commit('SET_HAS_CUPOM', data.hasCupom);
    if (data.hasCupom && data.cupomData && data.cupomData.campaign_coupon)
      commit('SET_CUPOM_CODE', data.cupomData.campaign_coupon);

    if (
      sectorsList.length === 1 &&
      !zeroSector &&
      !checkoutState[getters.eventID]
    )
      dispatch('setSkeleton', true);
    else dispatch('setSkeleton', false);
    console.log('setPurchaseStarted - setSectorsList - true');
    dispatch('setPurchaseStarted', true);
    dispatch('setTempSelectedSector', null);
  } catch (error) {
    console.error(
      `Failed retrieving products from event ${getters.eventID}`,
      error
    );
    throw error;
  } finally {
    dispatch('subtractLoading');
  }
};

export const setSectorMap = ({ commit }, sectorMap) => {
  commit('SET_SECTOR_MAP', sectorMap);
};

export const setTempSelectedSector = ({ commit }, setTempSelectedSector) => {
  commit('SET_TEMP_SELECTED_SECTOR', setTempSelectedSector);
};

export const setSelectedInfo = ({ commit }, selectedInfo) => {
  commit('SET_SELECTED_INFO', selectedInfo);
};

export const setSelectedSector = async (
  { commit, dispatch, getters },
  selectedSector
) => {
  try {
    dispatch('addLoading');
    dispatch('setSkeleton', true);
    commit('SET_SHOW_DEFAULT', false);
    commit('SET_SELECTED_SECTOR', null);
    commit('SET_SECTOR_MAP', null);
    let eventID = getters.eventID;
    const { data } = await $http.get(
      `v2/events/seats/list?event_id=${eventID}&sector_id=${selectedSector.codigo}&coupon=${getters.cupomCode}`
    );

    const sectorMap = data;
    commit('SET_CREATE_ORDER_IN_PROGRESS', false);
    commit('SET_SELECTED_SECTOR', selectedSector);
    commit('SET_SECTOR_MAP', sectorMap);
  } catch (error) {
    console.error(
      `Failed retrieving products from event ${getters.eventID}`,
      error
    );
    throw error;
  } finally {
    dispatch('subtractLoading');
    dispatch('setSkeleton', false);
  }
};

export const setCartProducts = ({ commit }, products) => {
  commit('SET_CART_PRODUCTS', products);
};

export const addCartProduct = ({ commit }, product) => {
  commit('ADD_CART_PRODUCT', product);
};

export const removeCartProduct = ({ commit }, product) => {
  commit('REMOVE_CART_PRODUCT', product);
};

export const setCupomCode = ({ commit }, cupomCode) => {
  commit('SET_CUPOM_CODE', cupomCode);
};

export const setTicketCodeUrl = ({ commit }, value) => {
  commit('SET_TICKET_CODE_URL', value);
};

export const setProductsCodeUrl = ({ commit }, value) => {
  commit('SET_PRODUCTS_CODE_URL', value);
};

export const getQueue = ({ commit }, params) => {
  return $http
    .get(`queue/session/${params.event}/${params.uuid}`)
    .then(resp => {
      return resp;
    });
};
